<span class="wk8-book-text" style="display: inline-block; font-family: Lexy2000">
  <ng-content></ng-content>
</span>
